<template>
<div class="card">
    <div class="card-header bg-info">
        <h3 class="my-0">Otras configuraciones</h3>
    </div>
    <div class="card-body">
        <form autocomplete="off" @submit.prevent="submit">
            <div class="row">
                <div class="col-md-6">
                    
                    <label class="control-label">
                        Mostrar publicidad
                        <el-tooltip class="item"
                                    content="Se visualizará la imágen cargada en el header de todos los clientes."
                                    effect="dark"
                                    placement="top-start">
                            <i class="fa fa-info-circle"></i>
                        </el-tooltip>
                    </label>
                    
                    <div :class="{'has-danger': errors.tenant_show_ads}"
                            class="form-group">
                        <el-switch v-model="form.tenant_show_ads"
                                    active-text="Si"
                                    inactive-text="No"
                                    @change="submit"></el-switch>
                        <small v-if="errors.tenant_show_ads"
                                class="form-control-feedback"
                                v-text="errors.tenant_show_ads[0]"></small>
                    </div>
                </div>

                <div class="col-md-6" v-if="form.tenant_show_ads">
                    <div class="form-group">
                        <label class="control-label">Imágen para publicidad</label>
                        <el-input v-model="form.tenant_image_ads" :readonly="true">
                            <el-upload
                                slot="append"
                                :headers="headers"
                                :on-success="successUpload"
                                :on-error="errorUpload"
                                :show-file-list="false"
                                action="/configurations/upload-tenant-ads">
                                <el-button icon="el-icon-upload" type="primary"></el-button>
                            </el-upload>
                        </el-input>
                        <div class="sub-title text-danger"><small>Se recomienda resoluciones 500x50</small>
                        </div>
                    </div>
                </div>

                
                <div class="col-md-6">
                    
                    <label class="control-label">
                        Habilitar contraseña segura
                        <el-tooltip class="item"
                                    content="Se solicitará una contraseña segura (cumplir patrón) al registrar cliente"
                                    effect="dark"
                                    placement="top-start">
                            <i class="fa fa-info-circle"></i>
                        </el-tooltip>
                    </label>
                    
                    <div :class="{'has-danger': errors.regex_password_client}"
                            class="form-group">
                        <el-switch v-model="form.regex_password_client"
                                    active-text="Si"
                                    inactive-text="No"
                                    @change="submit"></el-switch>
                        <small v-if="errors.regex_password_client"
                                class="form-control-feedback"
                                v-text="errors.regex_password_client[0]"></small>
                    </div>
                </div>

                <div class="col-md-12">
                    <label class="control-label">
                        Configurar fecha de Comprobantes rechazados en el mes actual
                        <el-tooltip class="item"
                                    content="SI: podran cambiar el mes, NO: mes actual"
                                    effect="dark"
                                    placement="top-start">
                            <i class="fa fa-info-circle"></i>
                        </el-tooltip>
                        <el-tooltip class="item ml-1"
                                    content="esta configuracion, es para el listado de sistemas de cliente, en la columna notificaciones: Comprobantes rechazados"
                                    effect="dark"
                                    placement="top-start">
                            <i class="fa fa-info-circle"></i>
                        </el-tooltip>
                    </label>
                    <div class="form-group" :class="{'has-danger': errors.rejected_documents_current_month}">
                        <el-switch
                            active-text="Si"
                            inactive-text="No"
                            v-model="form.rejected_documents_current_month"
                            @change="submit2"
                        ></el-switch>
                        <small v-if="errors.rejected_documents_current_month"
                                class="form-control-feedback"
                                v-text="errors.rejected_documents_current_month[0]"></small>
                    </div>
                </div>
                <template v-if="form.rejected_documents_current_month">
                    <div class="col-md-6">
                        <label class="control-label">
                            Periodo
                        </label>
                        <el-select v-model="period">
                            <el-option key="month" value="month" label="Por mes"></el-option>
                        </el-select>
                    </div>
                    <div class="col-md-6">
                        <label class="control-label">
                            Mes de
                        </label>
                        <el-date-picker v-model="form.rejected_documents_date" type="month"
                                        value-format="yyyy-MM" format="MM/yyyy" :clearable="false"></el-date-picker>
                    </div>
                    <div class="col-12 mt-3">
                        <el-button type="primary" @click.prevent="submit"
                            :loading="loading_submit"
                        >
                            Guardar
                        </el-button>
                    </div>
                </template>

                <div class="col-12">
                    <div class="form-group">
                        <label class="control-label">
                            Mostrar documentación de usuario
                        </label>
                        <br>
                        <el-switch
                            active-text="Si"
                            inactive-text="No"
                            v-model="form.show_documentation_user"
                            @change="submit"
                        ></el-switch>
                    </div>
                </div>
                <template v-if="form.show_documentation_user">
                    <div class="col-12">
                        <div class="form-group mb-2">
                            <label class="control-label">
                                Ayuda / URL documentación de usuario
                            </label>
                            <el-input v-model="form.url_documentation"></el-input>
                        </div>
                        <el-button type="primary"
                            size="small"
                            @click.prevent="saveURLDocumentation"
                            :loading="loading_url_documentation"
                        >Guardar</el-button>
                    </div>
                </template>

                <div class="col-md-6">
                    
                    <label class="control-label">
                        Bloquear cierre de notificaciones en la web
                        <el-tooltip class="item"
                                    content="Si está activo, el cliente no podrá cerrar la notificación desde el sistema web."
                                    effect="dark"
                                    placement="top-start">
                            <i class="fa fa-info-circle"></i>
                        </el-tooltip>
                    </label>
                    
                    <div :class="{'has-danger': errors.lock_close_notification}"
                            class="form-group">
                        <el-switch v-model="form.lock_close_notification"
                                    active-text="Si"
                                    inactive-text="No"
                                    @change="submit"></el-switch>
                        <small v-if="errors.lock_close_notification"
                                class="form-control-feedback"
                                v-text="errors.lock_close_notification[0]"></small>
                    </div>
                </div>

                <div class="col-md-6">

                    <label class="control-label">
                        Bloquear cierre de notificaciones en el app
                        <el-tooltip class="item"
                                    content="Si está activo, el cliente no podrá cerrar la notificación desde la aplicación móvil."
                                    effect="dark"
                                    placement="top-start">
                            <i class="fa fa-info-circle"></i>
                        </el-tooltip>
                    </label>

                    <div :class="{'has-danger': errors.lock_close_notification_app}"
                            class="form-group">
                        <el-switch v-model="form.lock_close_notification_app"
                                    active-text="Si"
                                    inactive-text="No"
                                    @change="submit"></el-switch>
                        <small v-if="errors.lock_close_notification_app"
                                class="form-control-feedback"
                                v-text="errors.lock_close_notification_app[0]"></small>
                    </div>
                </div>

                <div class="col-12 mt-2 border-bottom">
                    <h3>Icono de Whatsapp de soporte</h3>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{'has-danger': errors.phone}">
                        <label class="control-label">Teléfono</label>
                        <el-input v-model="form.phone">
                            <el-button slot="append" type="primary"
                                @click="submit3"
                                :loading="loading_submit3"
                            >
                                <i class="fa fa-save"></i>
                            </el-button>
                        </el-input>
                        <small class="form-control-feedback text-muted">Agregar codigo de pais, ejemplo; 51955955955</small>
                        <small class="form-control-feedback" v-if="errors.phone" v-text="errors.phone[0]"></small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group"
                        :class="{'has-danger': errors.enable_whatsapp}">
                        <label class="control-label">Ver icono de soporte</label>
                        <br>
                        <el-switch
                            v-model="form.enable_whatsapp"
                            active-text="Si"
                            inactive-text="No"
                            @change="submit3">
                        </el-switch>
                        <small class="form-control-feedback" v-if="errors.enable_whatsapp" v-text="errors.enable_whatsapp[0]"></small>
                        <br>
                        <small class="form-control-feedback">Se mostrará un icono de Whatsapp en cada cliente.</small>
                    </div>
                </div>

                <div class="col-12 mt-2 border-bottom">
                    <h3>Logo de la empresa</h3>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="control-label">
                            Logo (modo claro)
                            <el-tooltip content="Logo para tamaño A4/A5" placement="top">
                                <i class="fa fa-info-circle"></i>
                            </el-tooltip>
                        </label>
                        <template v-if="form.logo_footer_pdf">
                            <br>
                            <img :src="url_logo_footer_pdf"
                                style="max-width: 100%; height: auto; margin-bottom: 5px;">
                        </template>
                        <div>
                            <small>Se recomienda resoluciones 700x300</small>
                        </div>
                        <el-upload
                            :action="`/${this.resource}/upload-logo-footer-pdf`"
                            :data="{'type': 'light'}"
                            :headers="headers"
                            :on-success="successUploadFooterPdf"
                            :on-error="errorUploadFooterPdf"
                            :show-file-list="false"
                            style="width: 100%;"
                        >
                          <el-button type="primary" icon="el-icon-upload" class="btn-block" >
                            Subir logo
                          </el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="control-label">
                            Logo (modo oscuro)
                            <el-tooltip content="Logo para tamaño ticket (80, 58, 50)" placement="top">
                                <i class="fa fa-info-circle"></i>
                            </el-tooltip>
                        </label>
                        <template v-if="form.logo_footer_pdf_dark">
                            <br>
                            <img :src="url_logo_footer_pdf_dark"
                                style="max-width: 100%; height: auto; margin-bottom: 5px;">
                        </template>
                        <div>
                            <small>Se recomienda resoluciones 700x300</small>
                        </div>
                        <el-upload
                            :action="`/${this.resource}/upload-logo-footer-pdf`"
                            :data="{'type': 'dark'}"
                            :headers="headers"
                            :on-success="successUploadFooterPdfDark"
                            :on-error="errorUploadFooterPdfDark"
                            :show-file-list="false"
                            style="width: 100%;"
                        >
                          <el-button type="primary" icon="el-icon-upload" class="btn-block" >
                            Subir logo
                          </el-button>
                        </el-upload>
                    </div>
                </div>
            </div>
            <!-- <div class="form-actions text-right pt-2">
                <el-button type="primary" native-type="submit" :loading="loading_submit">Guardar</el-button>
            </div> -->
        </form>
    </div>
</div>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        return {
            headers: headers_token,
            loading_submit: false,
            resource: 'configurations',
            errors: {},
            form: {},
            period: 'month',
            loading_submit3: false,
            loading_url_documentation: false,
            version: Date.now(),
            version_dark: Date.now()
        }
    },

    computed: {
        url_logo_footer_pdf() {
            return `/storage/image_footer_pdf/${this.form.logo_footer_pdf}?t=${this.version}`
        },
        url_logo_footer_pdf_dark() {
            return `/storage/image_footer_pdf/${this.form.logo_footer_pdf_dark}?t=${this.version_dark}`
        },
    },

    async created() {
        await this.initForm()
        await this.getData()
    },
    methods: {
        async getData()
        {
            await this.$http.get(`/${this.resource}/get-other-configuration`)
                .then(response => {
                    this.form = response.data
                    if (!this.form.rejected_documents_date) {
                        this.form.rejected_documents_date = moment().format('YYYY-MM')
                    }
                })
                .catch(error => {
                    if (error.response) {
                        let message = error.response.data.message || 'Ocurrio un error inesperado'
                        this.$message.error(message)
                    }
                })
        },
        successUpload(response, file, fileList) 
        { 
            if (response.success) {
                this.$message.success(response.message)
                this.form.tenant_image_ads = response.name
            } else {
                this.$message({message: 'Error al subir el archivo', type: 'error'})
            }
        },
        errorUpload(error)
        {
            this.$message({message: 'Error al subir el archivo', type: 'error'})
        },
        initForm() {
            this.errors = {}
            this.form = {
                regex_password_client: false,
                tenant_show_ads: false,
                tenant_image_ads: null,
                rejected_documents_current_month: false,
                rejected_documents_date: moment().format('YYYY-MM'),
                phone: null,
                enable_whatsapp: false,
                show_documentation_user: false,
                url_documentation: null,
                logo_footer_pdf: null,
                logo_footer_pdf_dark: null,
                lock_close_notification: false,
                lock_close_notification_app: false,
            }
        },
        submit() {
            this.loading_submit = true
            this.$http
                .post(`/${this.resource}/other-configuration`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        console.log(error)
                        if (error.response) {
                            let message = error.response.data.message || 'Ocurrio un error inesperado'
                            this.$message.error(message)
                        }
                    }
                })
                .then(() => {
                    this.loading_submit = false
                })
        },

        async submit2() {
            if (!this.form.rejected_documents_current_month) {
                this.submit()
            }
        },

        async submit3() {
            const sendData = {
                enable_whatsapp: this.form.enable_whatsapp,
                phone: this.form.phone
            }
            try {
                this.loading_submit3 = true
                const response = await this.$http.post(`/users/update-others`, sendData)
                const { data } = response
                if (data.success) {
                    this.$message.success(data.message)
                } else {
                    this.$message.error(data.message)
                }
            } catch (error) {
                console.log(error)
                if (error.response) {
                    let message = error.response.data.message || 'Ocurrio un error inesperado'
                    this.$message.error(message)
                }
            } finally {
                this.loading_submit3 = false
            }
        },

        async saveURLDocumentation() {
            try {
                this.loading_url_documentation = true
                const { data } = await this.$http.post(`/${this.resource}/update-url-documentation`, this.form)
                if (data.success) {
                    this.$message.success(data.message)
                } else {
                    this.$message.error(data.message)
                }
            } catch (error) {
                if (error.response) {
                    let message = error.response.data.message || 'Ocurrio un error inesperado'
                    this.$message.error(message)
                }
            } finally {
                this.loading_url_documentation = false
            }
        },

        async successUploadFooterPdf(response) {
            if (response.success) {
                this.$message.success(response.message)
                this.version = Date.now()
                await this.getData()
            } else {
                this.$message.error(response.message)
            }
        },

        errorUploadFooterPdf(err) {
            this.$message.error('Error al subir el archivo')
        },

        async successUploadFooterPdfDark(response) {
            if (response.success) {
                this.$message.success(response.message)
                this.version_dark = Date.now()
                await this.getData()
            } else {
                this.$message.error(response.message)
            }
        },

        errorUploadFooterPdfDark(err) {
            this.$message.error('Error al subir el archivo')
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/system/configuration/other_configuration.vue